<script lang="ts" setup>
import { getApiErrorMessage } from '../libs/apiErrors'
import { ref } from 'vue'
import { AlbumSummary, User } from '../../../libs/models'
import { useApi } from '../libs/api'
import AlbumDetailModal from './AlbumDetailModal.vue'
import AlbumList from './AlbumList.vue'
import Loading from './Loading.vue'
import Modal from './Modal.vue'

const props = defineProps<{ user: User }>()
const emit = defineEmits(['close'])

const api = useApi()
const albums = ref<AlbumSummary[]>([])
const selectedAlbum = ref<AlbumSummary | null>(null)
const isLoading = ref(true)

api.get<AlbumSummary[]>(`/users/${props.user.id}/albums`).then(({ data }) => {
  albums.value = data
}).catch(error => {
  alert(getApiErrorMessage(error, 'アルバムを取得できませんでした'))
  emit('close')
}).finally(() => {
  isLoading.value = false
})

const updateAlbumSummary = (album: AlbumSummary) => {
  albums.value = albums.value.map(item => item.id === album.id ? album : item)
  selectedAlbum.value = album
}
</script>

<template>
  <transition name="modal">
    <AlbumDetailModal v-if="selectedAlbum" :key="`detail:${selectedAlbum.id}`" :album="selectedAlbum" @close="selectedAlbum = null" @update="updateAlbumSummary" />
    <Modal v-else key="list" @close="$emit('close')">
      <div class="ModalContent UserAlbumsContent">
        <div class="ModalTitle">{{ l('{name}さんのアルバム一覧', { name: user.name }) }}</div>
        <Loading v-if="isLoading" class="AlbumsLoading" />
        <div v-else-if="!albums.length" class="EmptyState">{{ l('アルバムがまだありません') }}</div>
        <AlbumList v-else :albums="albums" @select="selectedAlbum = $event" />
        <button class="cancel" @click="$emit('close')">{{ l('閉じる') }}</button>
      </div>
    </Modal>
  </transition>
</template>

<style lang="scss" scoped>
.UserAlbumsContent {
  width: 600px;
  max-width: calc(100vw - 30px);
  line-height: 1.5;
  > button { margin-top: 10px; }
}
.AlbumsLoading { margin: 40px auto; }
.EmptyState { padding: 40px 10px; color: var(--tx-color-light); font-size: 13px; text-align: center; }
</style>
